import brands from "@/pages/cars/brands";
import models from "@/pages/cars/models";
import types from "@/pages/cars/types";
import SingleType from "@/pages/cars/singleType";
import parts from "@/pages/cars/parts";
import showCarPart from "@/pages/cars/showCarPart";

const routes = [
  {
    path:'/cars',
    component:brands,
    meta:{requiredAuth:true}
  },
  {
    path:'/cars/brand/:brandId',
    component:models,
    meta:{requiredAuth:true}
  },
  {
    path:'/cars/model/:modelId',
    component:types,
    meta:{requiredAuth:true}
  },
  {
    path:'/cars/type/:typeId',
    component:SingleType  ,
    meta:{requiredAuth:true}
  },
  {
    path:'/cars/parts/:typeId/:partId?',
    component:parts  ,
    meta:{requiredAuth:true},
  },
  {
    path:'/cars/showPart/:typeId/:partId',
    component:showCarPart  ,
    meta:{requiredAuth:true},
  },
]

export default routes;